import NetworkBar from './NetworkBar';
import NetworkBarContainer from './NetworkBar.container';
export default NetworkBarContainer(NetworkBar);
